import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TextDivider from '../../../elements/text-divider/TextDivider';
import { StyledInputsContainer } from '../styles';

const HighlightParamsFormSection = ({ control, errors }) => {
  const { t } = useTranslation();

  return (
    <>
      <TextDivider>
        {t('search.highlightOptions', { ns: 'sectionTitles' })}
      </TextDivider>
      <StyledInputsContainer>
        <Box>
          <Controller
            name="settings.query.jsonQuery.params.fl"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextField
                {...field}
                label={t('search.highlightFields', { ns: 'fields' })}
                variant="outlined"
                size="small"
                fullWidth
                inputProps={{ 'aria-label': 'highlight field' }}
                error={!!errors?.settings?.query?.jsonQuery?.params?.fl}
                helperText={
                  errors?.settings?.query?.jsonQuery?.params?.fl?.message
                }
              />
            )}
          />
        </Box>
      </StyledInputsContainer>
      <Grid container sx={{ mt: '1em' }}>
        <Grid size={12}>
          <FormGroup row>
            {[
              'requireFieldMatch',
              'usePhraseHighLighter',
              'highlightMultiTerm',
            ].map((fieldName) => (
              <FormControlLabel
                key={fieldName}
                label={t(`search.${fieldName}`, { ns: 'fields' })}
                control={
                  <Controller
                    name={`settings.query.jsonQuery.params.${fieldName}`}
                    control={control}
                    render={({ field: { value, ...field } }) => (
                      <Checkbox
                        {...field}
                        checked={!!value}
                        inputProps={{ 'aria-label': fieldName }}
                      />
                    )}
                  />
                }
              />
            ))}
          </FormGroup>
        </Grid>
      </Grid>
    </>
  );
};

HighlightParamsFormSection.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default HighlightParamsFormSection;
